import actionTypes from "./actionTypes"

export const getRetailerProducts = async (retailerId, dispatch) => {
  const result = await fetch(
    `${process.env.REACT_APP_PRODUCT_DATA_FEED}/v1/retailer/${retailerId}/retailer-products`
  ).then((r) => r.json())
  dispatch({
    type: actionTypes.SET_RETAILER,
    retailerId,
    retailerProducts: result,
  })
}
